import { useTranslations } from 'next-intl';

import { Button } from '@/components/button';
import { getTelegramNetwork } from '@/lib/telegram';
import { copyToClipboard } from '@/utils/copyToClipboard';

export default function TelegramSetupInstructions({ command, network }: { command?: string | null; network?: string | null }) {
  const t = useTranslations('settings.telegram');
  if (network && !getTelegramNetwork(network)) return <p className="text-text-secondary">{t('unsupportedNetwork')}</p>;
  if (!command) return null;
  return (
    <div className="flex flex-col gap-3 rounded-lg border border-border-primary p-4">
      <p className="text-text-secondary">{t('manualInstructions')}</p>
      <code className="wrap-break-word text-sm text-text-primary">{command}</code>
      <Button variant="secondary" onClick={() => copyToClipboard(command, t('commandCopied'))}>
        {t('copyCommand')}
      </Button>
    </div>
  );
}
